<template lang="pug">
#other-office-room-schedule-list
  .box
    .box-header(v-if="_overBasicPlanByFamilyService && _useRoomSchedulesFunction")
      .d-flex.justify-content-start.align-items-center
        .note.d-flex.justify-content-start.flex-column
          span 連携済みの他事業所の空床情報を確認できます（確認可能なのは情報公開している事業所のみ）。
          span 空床情報公開には家族連絡サービスのベーシックプラン契約が必要です（他事業所の情報確認は契約プランに関係なく可能です）。
        .d-flex.justify-content-end.align-items-start.align-self-stretch.flex-fill
          button.btn.setting-btn.mr-2(@click="gotoSetting") 公開設定
          button.btn.schedule-btn(@click="gotoFamiliesRoomSchedule") 自施設の空床スケジュール
    .box-body
      b-tabs(v-model="tabIndex" @activate-tab="activateTab" @changed="changedTab")
        //- 空床情報タブ
        b-tab
          template(v-slot:title)
            .tab-title
              span.mr-1 空床情報
          RoomScheduleTab(ref="roomScheduleTab" :selectedFacilities.sync="selectedFacilities")
        //- 受入リクエスト（メッセージ作成タブ）
        b-tab(:disabled="selectedFacilities.length < 1")
          template(v-slot:title)
            .tab-title
              span メッセージ作成
          SendRequestTab(ref="sendRequestTab" :targetFacilities="selectedFacilities" @sendRequest="confirmSendRequest")
        //- 送信履歴タブ
        b-tab
          template(v-slot:title)
            .tab-title
              span 送信履歴
          SendRequestHistoriesTab(ref="sendRequestHistoriesTab" @onChangeEnded="changeStatus" @onRepliesDetail="onRepliesDetail")
        //- 送信履歴（返信状況）タブ
        b-tab(v-if="showSendRequestRepliesTab")
          template(v-slot:title)
            .tab-title
              span.message-detail-tab-title-text.text-truncate.d-inline-block 送信履歴（返信状況）
              button.close(type="button" @click="closeSendRequestRepliesTab") x
          SendRequestRepliesTab(:request="requestForSendRequestRepliesTab" :replies="repliesForSendRequestRepliesTab" @sendReply="sendRequestReply")
        //- 返信履歴タブ
        b-tab
          template(v-slot:title)
            .tab-title.d-flex.flex-row.align-items-center
              span.mr-1 返信履歴
              .noreply-badge-content
                b-badge.noreply-badge(v-if="0 < _noreplyReceiveRequestCount" pill variant="sidemenu-badge") {{ _noreplyReceiveRequestCount }}
          ReceiveRequestHistoriesTab(ref="receiveRequestHistoriesTab" @onReply="onReply")
        //- 返信入力タブ
        b-tab(v-if="showInputReplyForReceiveRequestTab")
          template(v-slot:title)
            .tab-title
              span.message-detail-tab-title-text.text-truncate.d-inline-block.mr-2 返信入力
              button.close(type="button" @click="closeInputReplyForReceiveRequestTab") x
          InputReplyForReceiveRequestTab(:replyTarget="replyTargetForInputReplyRequestTab" :replies="repliesForInputReplyForReceiveRequestTab"
            @sendReply="sendReceiveReply")
  //- 受入 リクエスト
  OkCancelModal(v-model="showRequestRegisterModal" title="メッセージを送信しますか？" @ok="sendRequest")
  OkModal(v-model="showRequestRegisterSuccessModal" title="送信に成功しました。")
  
  //- リクエスト返信（共通）
  OkModal(v-model="showReplyRegisterSuccessModal" title="送信に成功しました。")
  
  PageLoading(:isBusy="isBusy" :message="loadingMessage")
</template>

<script lang="ts">
import { Component, Inject, Ref, Vue } from "vue-property-decorator";

import { userStore } from "@/store/store";
import { PcUrl } from "@/commons/constants/PcUrl";
import SystemError from "@/commons/models/SystemError";

import { PlanType } from "@/commons/services/Plans";
import OtherOfficeAcceptanceRequestsService, {
  OtherOfficeAcceptanceRequestsPostModel,
  OtherOfficeAcceptanceRequestsPatchModel,
  OtherOfficeAcceptanceRequestsGetModel
} from "@/commons/services/OtherOfficeAcceptanceRequests";
import OtherOfficeAcceptanceRequestRepliesService, {
  Acceptance,
  OtherOfficeAcceptanceRequestRepliesGetModel,
  OtherOfficeAcceptanceRequestRepliesPostModel
} from "@/commons/services/OtherOfficeAcceptanceRequestReplies";

import RoomScheduleTab from "@/pc/containers/otherOfficeRoomSchedules/RoomScheduleTab.vue";
import SendRequestTab from "@/pc/containers/otherOfficeRoomSchedules/SendRequestTab.vue";
import SendRequestHistoriesTab from "@/pc/containers/otherOfficeRoomSchedules/SendRequestHistoriesTab.vue";
import SendRequestRepliesTab, { SendRequestRepliesModel } from "@/pc/containers/otherOfficeRoomSchedules/SendRequestRepliesTab.vue";
import ReceiveRequestHistoriesTab from "@/pc/containers/otherOfficeRoomSchedules/ReceiveRequestHistoriesTab.vue";
import InputReplyForReceiveRequestTab from "@/pc/containers/otherOfficeRoomSchedules/InputReplyForReceiveRequestTab.vue";

import PageLoading from "@/pc/basics/PageLoading.vue";
import OkCancelModal from "@/pc/basics/OkCancelModal.vue";
import OkModal from "@/pc/basics/OkModal.vue";
import { SendRequestHistoriesTableItem } from "@/pc/containers/otherOfficeRoomSchedules/SendRequestHistoriesTable.vue";
import { ReceiveRequestHistoriesTableItem } from "@/pc/containers/otherOfficeRoomSchedules/ReceiveRequestHistoriesTable.vue";

/**
 * ### 活動予定・履歴コンポーネント
 */
@Component({
  components: {
    RoomScheduleTab,
    SendRequestTab,
    SendRequestHistoriesTab,
    SendRequestRepliesTab,
    ReceiveRequestHistoriesTab,
    InputReplyForReceiveRequestTab,
    PageLoading,
    OkCancelModal,
    OkModal
  }
})
export default class RoomScheduleList extends Vue {
  /** 受入 リクエストサービス */
  @Inject("OtherOfficeAcceptanceRequestsService") requestsService!: OtherOfficeAcceptanceRequestsService;
  /** 受入リクエスト返信サービス */
  @Inject("OtherOfficeAcceptanceRequestRepliesService") requestRepliesService!: OtherOfficeAcceptanceRequestRepliesService;

  /** 空床情報タブ */
  @Ref() roomScheduleTab!: RoomScheduleTab;
  /** メッセージ作成タブ */
  @Ref() sendRequestTab!: SendRequestTab;
  /** 送信履歴 */
  @Ref() sendRequestHistoriesTab!: SendRequestHistoriesTab;
  /** 返信履歴タブ */
  @Ref() receiveRequestHistoriesTab!: ReceiveRequestHistoriesTab;

  /** タブインデックス(0始まり) */
  tabIndex: number = 0;

  /** ページ全体ローディング表示可否 */
  isBusy: boolean = false;
  /** ローディングメッセージ */
  loadingMessage: string = "";

  /** 空床情報タブで選択し、受入リクエストタブで送信対象となる施設情報 */
  selectedFacilities: Array<{ facilityId: number; facilityName: string }> = [];

  /** 受入リクエスト */
  otherOfficeAcceptanceRequestsPostModel: OtherOfficeAcceptanceRequestsPostModel | null = null;
  /** 受入リクエスト確認モーダル表示可否 */
  showRequestRegisterModal: boolean = false;
  /** 受入リクエスト完了モーダル表示可否 */
  showRequestRegisterSuccessModal: boolean = false;

  /** リクエスト返信詳細タブ表示可否 */
  showSendRequestRepliesTab: boolean = false;
  /** リクエスト返信詳細タブの返信元リクエスト */
  requestForSendRequestRepliesTab: OtherOfficeAcceptanceRequestsGetModel | null = null;
  /** リクエスト返信詳細タブの返信リスト */
  repliesForSendRequestRepliesTab: SendRequestRepliesModel | null = null;

  /** 未返信のリクエストが存在するか否か */
  noreplyReceiveRequestCount: number = 0;

  /** 返信入力タブ表示可否 */
  showInputReplyForReceiveRequestTab: boolean = false;
  /** 返信対象のリクエスト */
  replyTargetForInputReplyRequestTab: ReceiveRequestHistoriesTableItem | null = null;
  /** 返信対象のリクエストに紐付く返信 */
  repliesForInputReplyForReceiveRequestTab: OtherOfficeAcceptanceRequestRepliesGetModel | null = null;

  /** リクエスト返信登録完了モーダル表示可否 */
  showReplyRegisterSuccessModal: boolean = false;

  get _useFamilyService(): boolean {
    return userStore.facility.useFamilyService;
  }

  /** ### プランがベーシック以上かを返す */
  get _overBasicPlanByFamilyService(): boolean {
    // 家族連絡サービス未契約の場合はベーシック以上ではない
    if (userStore.facility.useFamilyService != true) {
      return false;
    }
    // ベーシックプラン以上かを返す
    const planType: PlanType = userStore.facility.planType;
    if (PlanType.BASIC <= planType) {
      return true;
    } else {
      return false;
    }
  }

  /** ### 他事業所連携サービス、空床情報の使用可否を返す */
  get _useRoomSchedulesFunction(): boolean {
    return userStore.loginUser.permissions.functions.roomSchedulesFunction;
  }

  get _noreplyReceiveRequestCount(): number {
    return this.noreplyReceiveRequestCount;
  }

  /** ### vue lifecycle mounted */
  mounted(): void {
    this.setNoreplyReceiveRequestCount(); // ローディングを出す必要が無いので非同期で呼び出す
    return;
  }

  /** ### 未返信のリクエスト数を設定する */
  async setNoreplyReceiveRequestCount(): Promise<void> {
    const noreplyReceiveRequestCount: number = await this.getExistIncomingReceiveRequest();
    this.noreplyReceiveRequestCount = noreplyReceiveRequestCount;
    return;
  }

  /** ### 未返信のリクエスト数を取得する */
  async getExistIncomingReceiveRequest(): Promise<number> {
    const response: number = await this.requestsService.existNoreply(userStore);
    return response;
  }

  /** ### 空室／空床情報の設定画面へ遷移する */
  gotoSetting(): void {
    this.$router.push({ name: PcUrl.RoomScheduleSetting, params: { type: "1" } });
    return;
  }

  /** ### 空室／空床情報の設定画面へ遷移する */
  gotoFamiliesRoomSchedule(): void {
    this.$router.push(PcUrl.RoomScheduleList);
    return;
  }

  /** リクエスト登録確認モーダルを表示する */
  confirmSendRequest(requestBody: OtherOfficeAcceptanceRequestsPostModel): void {
    this.otherOfficeAcceptanceRequestsPostModel = requestBody;
    this.showRequestRegisterModal = true;
    return;
  }

  /** リクエスト登録 */
  async sendRequest(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "送信中...";

    await this.requestsService.post(userStore, this.otherOfficeAcceptanceRequestsPostModel!);
    this.showRequestRegisterSuccessModal = true;

    this.isBusy = false;

    // TODO 本来なら非同期で取得し直すなどの対応が良いが、時間が無いので同期で取得しなおす
    await this.sendRequestHistoriesTab.refresh();
    // 入力項目のリセット
    this.selectedFacilities = [];
    this.roomScheduleTab.initializeChecked();
    this.sendRequestTab.initialize();
    // 送信したので送信履歴タブをアクティブにする
    this.tabIndex = 2;

    return;
  }

  /** ### 受入リクエストの状態を更新する */
  async changeStatus(item: SendRequestHistoriesTableItem): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "更新中...";

    const requestBody: OtherOfficeAcceptanceRequestsPatchModel = {
      updateType: "status",
      messageText: undefined,
      ended: item.ended,
      updated: item.updated
    };
    const response: OtherOfficeAcceptanceRequestsGetModel = await this.requestsService.patch(userStore, item.datetime, requestBody);

    // updatedが更新されたものが返却されるので、値を更新してリスト自体の更新はしない
    item.updated = response.updated;

    this.isBusy = false;

    return;
  }

  /**
   * ### リクエストの返信詳細タブを表示する
   */
  async onRepliesDetail(item: SendRequestHistoriesTableItem): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "取得中...";

    this.requestForSendRequestRepliesTab = item;

    const replies = await this.getSendRequestReplies(item);
    const formatedReplies = this.formatRepliesForSendRequestRepliesTab(item, replies);
    this.repliesForSendRequestRepliesTab = formatedReplies;

    this.showSendRequestRepliesTab = true;

    this.isBusy = false;

    return;
  }

  /**
   * ### リクエストの返信を取得する
   */
  private async getSendRequestReplies(item: SendRequestHistoriesTableItem): Promise<Array<OtherOfficeAcceptanceRequestRepliesGetModel>> {
    let response: Array<OtherOfficeAcceptanceRequestRepliesGetModel> = [];

    try {
      response = await this.requestRepliesService.gets(userStore, item.datetime);
    } catch (error) {
      const systemerror: SystemError = error as SystemError;
      // 413エラーの場合、全件取得した結果がペイロード制限に引っかかったことになるので、index指定で段階的に取得する
      if (systemerror.statusCode == 413) {
        const count: number = await this.requestRepliesService.getCount(userStore, item.datetime);
        const loopEnd: number = Math.ceil(count / 50);

        for (let i = 0; i < loopEnd; i++) {
          const params: { startIndex: number; endIndex: number } = {
            startIndex: i * 50,
            endIndex: i * 50 + 50
          };
          response = response.concat(await this.requestRepliesService.gets(userStore, item.datetime, params));
        }
      }
    }
    return response;
  }

  /**
   * ### リクエストの返信を表示用に仕訳する
   */
  private formatRepliesForSendRequestRepliesTab(item: SendRequestHistoriesTableItem, replies: Array<OtherOfficeAcceptanceRequestRepliesGetModel>): SendRequestRepliesModel {
    const sendRequestRepliesModel: SendRequestRepliesModel = {
      possibleItems: [],
      needConsultationItems: [],
      notPossibleItems: [],
      replyItems: [],
      noReplyItems: []
    };

    // 受け入れ可否確認をする場合、返信済み以外に振り分ける
    if (item.replyAcceptance) {
      for (const reply of replies) {
        if (reply.firstReply) {
          switch (reply.latestAcceptance) {
            case Acceptance.POSSIBLE: {
              sendRequestRepliesModel.possibleItems.push(reply);
              break;
            }
            case Acceptance.NEED_CONSULTATION: {
              sendRequestRepliesModel.needConsultationItems.push(reply);
              break;
            }
            case Acceptance.NOT_POSSIBLE: {
              sendRequestRepliesModel.notPossibleItems.push(reply);
              break;
            }
            default: {
              break;
            }
          }
        } else {
          sendRequestRepliesModel.noReplyItems.push(reply);
        }
      }
    }
    // 受け入れ可否確認をしない場合、返信済みと未返信に振り分ける
    else {
      for (const reply of replies) {
        if (reply.firstReply) {
          sendRequestRepliesModel.replyItems.push(reply);
        } else {
          sendRequestRepliesModel.noReplyItems.push(reply);
        }
      }
    }
    return sendRequestRepliesModel;
  }

  /**
   * ### 送信リクエストへの返信（返信への返信）
   */
  async sendRequestReply(requestBody: OtherOfficeAcceptanceRequestRepliesPostModel): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "送信中...";

    await this.requestRepliesService.post(userStore, requestBody);
    this.showReplyRegisterSuccessModal = true;

    // 返信が完了したので、送信履歴（返信状況）タブを非表示にし、タブ位置を送信履歴タブにする
    this.showSendRequestRepliesTab = false;
    this.tabIndex = 2;

    this.isBusy = false;

    // TODO 本来なら非同期で取得し直すなどの対応が良いが、時間が無いので同期で取得しなおす
    await this.sendRequestHistoriesTab.refresh();

    return;
  }

  /**
   * ### 送信履歴（返信状況）タブを非表示にする
   *
   * - タブを非表示にする
   * - タブ位置を送信履歴タブにする
   */
  closeSendRequestRepliesTab(): void {
    this.showSendRequestRepliesTab = false;
    this.tabIndex = 2;
    return;
  }

  /**
   * ### リクエストの返信入力タブを表示する
   */
  async onReply(item: ReceiveRequestHistoriesTableItem): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "取得中...";

    this.replyTargetForInputReplyRequestTab = item;

    const replies = await this.getReceiveRequestReplies(item);
    this.repliesForInputReplyForReceiveRequestTab = replies[0];

    this.showInputReplyForReceiveRequestTab = true;

    this.isBusy = false;

    return;
  }

  /**
   * ### リクエストの返信を取得する
   */
  private async getReceiveRequestReplies(item: SendRequestHistoriesTableItem): Promise<Array<OtherOfficeAcceptanceRequestRepliesGetModel>> {
    let response: Array<OtherOfficeAcceptanceRequestRepliesGetModel> = [];

    try {
      response = await this.requestRepliesService.gets(userStore, item.datetime, { senderFacilityId: item.facilityId });
    } catch (error) {
      const systemerror: SystemError = error as SystemError;
      // 413エラーの場合、全件取得した結果がペイロード制限に引っかかったことになるので、index指定で段階的に取得する
      if (systemerror.statusCode == 413) {
        const count: number = await this.requestRepliesService.getCount(userStore, item.datetime);
        const loopEnd: number = Math.ceil(count / 50);

        for (let i = 0; i < loopEnd; i++) {
          const params: { startIndex: number; endIndex: number; senderFacilityId: number } = {
            startIndex: i * 50,
            endIndex: i * 50 + 50,
            senderFacilityId: item.facilityId
          };
          response = response.concat(await this.requestRepliesService.gets(userStore, item.datetime, params));
        }
      }
    }
    return response;
  }

  /**
   * ### 受信リクエストへの返信（通常返信）
   */
  async sendReceiveReply(requestBody: OtherOfficeAcceptanceRequestRepliesPostModel): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "送信中...";

    await this.requestRepliesService.post(userStore, requestBody);
    this.showReplyRegisterSuccessModal = true;

    // 返信が完了したので、返信入力タブを非表示にし、タブ位置を返信履歴タブにする
    this.showInputReplyForReceiveRequestTab = false;
    this.tabIndex = 3;

    this.isBusy = false;

    // TODO 本来なら非同期で取得し直すなどの対応が良いが、時間が無いので同期で取得しなおす
    await this.receiveRequestHistoriesTab.refresh();
    // 返信を登録すると未返信数が変わる可能性があるので未返信数を更新する
    await this.setNoreplyReceiveRequestCount();
    // サイドメニューの未返信数を更新するのでバッジ更新を呼び出す
    this.$emit("refresh");

    return;
  }

  /**
   * ### 返信入力タブを非表示にする
   *
   * - タブを非表示にする
   * - タブ位置を返信履歴タブにする
   */
  closeInputReplyForReceiveRequestTab(): void {
    this.showInputReplyForReceiveRequestTab = false;
    this.tabIndex = 3;
    return;
  }

  /** ### タブの追加・削除イベント */
  changedTab(): void {
    // 「送信履歴（返信状況）」タブが追加された場合にフォーカスを当てる
    if (this.showSendRequestRepliesTab) {
      // 「送信履歴（返信状況）」タブ（4番目）にフォーカスを当てる
      this.tabIndex = 3;
    }
    // 「返信入力」タブが追加された場合にフォーカスを当てる
    if (this.showInputReplyForReceiveRequestTab) {
      // 「返信入力」タブ（5番目）にフォーカスを当てる
      this.tabIndex = 4;
    }
    return;
  }

  /** ### タブがアクティブになった際のイベント */
  activateTab(newTabIndex: number, oldTabIndex: number): void {
    // 「送信履歴（返信状況）」タブ（インデックス3）から別のタブに移動した場合
    if (oldTabIndex === 3 && newTabIndex !== 3) {
      // 「送信履歴（返信状況）」タブを非表示にする
      this.showSendRequestRepliesTab = false;
    }
    // 「返信入力」タブ（インデックス4）から別のタブに移動した場合
    if (oldTabIndex === 4 && newTabIndex !== 4) {
      // 「送信履歴（返信状況）」タブを非表示にする
      this.showInputReplyForReceiveRequestTab = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.setting-btn {
  min-width: 95px;
}
.schedule-btn {
  min-width: 240px;
}

.box-body {
  .tab-title {
    height: 25px;
  }
  .noreply-badge-content {
    margin-top: -5px;
  }
}
</style>
